// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"24d1f7dc","498":"74a17922","703":"53f181a3"}[chunkId] + ".chunk.js";
};